module.exports = __webpack_public_path__ + "static/media/AppstoreIcon.bf1b1873.svg";